import { render, staticRenderFns } from "./GerenciamentoServicoListFiltro.vue?vue&type=template&id=acc660a0"
import script from "./GerenciamentoServicoListFiltro.vue?vue&type=script&lang=js"
export * from "./GerenciamentoServicoListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports